import { OmisUser } from './../../../models/data/user.model';
import { createAction, props } from '@ngrx/store';
import { Register } from 'src/app/models/data/register.model';
import { customerVisit, Preference, TimeSlotUser, User, UserAuth, UserCredential, UserLocation } from 'src/app/models/data/user.model';
import { APILoginOTPRequest, APILoginPasswordResetByOTPRequest, APILoginPasswordResetByTokenRequest, APILoginRequest } from 'src/app/models/interfaces/api-user.interface';

export const clearUserInfo = createAction(
  '[User] Clear User Info'
)

export const loadUsers = createAction(
  '[User] Load Users'
);

export const loadUsersSuccess = createAction(
  '[User] Load Users Success',
  props<{ data: any }>()
);

export const loadUsersFailure = createAction(
  '[User] Load Users Failure',
  props<{ error: any }>()
);

export const autoSignIn = createAction(
  "[User] Auto Sign In",
)

export const signIn = createAction(
  "[User] Sign In",
  props<{
    credentials: APILoginRequest,
  }>()
)

export const setCredentials = createAction(
  '[User] Set Credentials',
  props<{
    token: UserCredential;
  }>()
)

export const logIn = createAction(
  '[User] Log In',
  props<{
    credentials: APILoginRequest
    rememberAccount: boolean
    manuallyLogin: boolean
  }>()
)

export const fetchTSMSUserInfo = createAction(
  '[User] Fetch TSMS User Information',
)

export const fetchSiqUserInfo = createAction(
  '[User] Fetch Siq User Information',
)

export const invalidateToken = createAction(
  "[User] Invalidate Token",
  props<{
    context?: string
  }>()
)

export const logOut = createAction(
  "[User] Log Out"
)

export const signOut = createAction(
  "[User] Sign Out"
)

export const requestOTP = createAction(
  "[User] Request OTP",
  props<{
    body: APILoginOTPRequest
  }>()
)

export const setMaskedMobile = createAction(
  "[User] Set Masked Mobile",
  props<{
    mobile: string
  }>()
)

export const requestPasswordResetByToken = createAction(
  '[User] Request Password Reset By Token',
  props<{
    body: APILoginPasswordResetByTokenRequest
  }>()
)

export const updateUserToServer = createAction(
  '[User] Update User To Server',
)

export const setUserInfo = createAction(
  '[User] Set User Information',
  props<{
    user: User
  }>()
)

export const setTSMSUserInfo = createAction(
  '[User] Set TSMS User Information',
  props<{
    tsmsUser: TimeSlotUser
  }>()
)

export const setTimeslotBookingUser = createAction(
  '[User] Set Timeslot Booking User',
  props<{
    timeslotBookingUser: TimeSlotUser
  }>()
)


export const restoreUserSnapshot = createAction(
  '[User] Restore User Snapshot'
)

export const clearUserSnapshot = createAction(
  '[User] Clear User Snapshot'
)

export const snapshotUser = createAction(
  '[User] Snapshot User',
)

export const updatePartialUser = createAction(
  '[User] Update Partial User',
  props<{
    update: Partial<User>
  }>()
)

export const setuiloginFail = createAction(
  '[User] set Ui Login Fail',
  props<{
    uiloginFail: boolean
  }>()
)

export const clearuiloginFail = createAction(
  '[User] Clear Ui Login Fail'
)

export const setuiloginLoading = createAction(
  '[User] set Ui Login Loading',
  props<{
    loginLoading: boolean
  }>()
)

export const clearuiloginLoading = createAction(
  '[User] Clear Ui Login Loading'
)
// export const updatePreferences = createAction(
//   '[User] Update Preferences',
//   props<{
//     update: Partial<Preference>
//   }>()
// )


export const registNewAccout = createAction(
  '[User] Regist New Account',
  props<{
    register: Register
  }>()
)

export const registNewAccoutFail = createAction(
  '[User] Regist New Account Fail'
)

export const loadUserInStateAndSaveToCookie = createAction(
  '[User] Load User In State And Save To Cookie'
)

export const updateCurrentLocation = createAction(
  '[User] Update Current Location',
  props<{
    userLocation: UserLocation
  }>()
)

export const clearCurrentLocation = createAction(
  '[User] Clear Current Location'
)

export const updateCustomerVisit = createAction(
  '[User] Update Customer Visit',
  props<{
    customerVisit: customerVisit
  }>()
)

export const clearCustomerVisit = createAction(
  '[User] Clear Customer Visit'
)


export const updateModulePreferences = createAction(
  '[User] Update Module Preferences',
  props<{
    preferences: Preference
  }>()
)

export const fetchUserAuth = createAction(
  '[User] Fetch User Authrization',
)

export const setUserAuth = createAction(
  '[User] Set User Authrization',
  props<{
    userAuth: UserAuth[]
  }>()
)

export const upsertUserAuth = createAction(
  '[User] Set User Authrization for only one person',
  props<{
    userAuth: UserAuth
  }>()
)

export const clearUserAuth = createAction(
  '[User] Clear User Authrization'
)
